import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=5ec5b4b0&scoped=true&"
import script from "./Dataset.vue?vue&type=script&lang=ts&"
export * from "./Dataset.vue?vue&type=script&lang=ts&"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=5ec5b4b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5b4b0",
  null
  
)

export default component.exports